import useStore from "../../context/useStore";
import tools from "../../helpers/tools";

const useTVA = () => {
  const [state] = useStore();

  const getTVAByCatalog = (catalogUuid) => {
    if (!catalogUuid) {
      // eslint-disable-next-line no-console
      console.warn("TVA could not be found because catalogUuid is not defined");
      return { TVA: -1, TVA_INVERT: -1 };
    }
    const catalogRef = tools.findIn(
      state.catalogStore.items,
      "uuid",
      catalogUuid
    );
    if (!catalogRef?.geographicZone) {
      // LS-637 — catalogRef est souvent absent transitoirement, pas définitivement :
      // le catalogue du véhicule n'est pas dans le périmètre UserGroup de l'utilisateur
      // (Catalog::scopeVisiblePour côté API), et FinanceDetailV2 le charge de façon
      // asynchrone (chargerCataloguesManquants) après le premier rendu. getTVAByCatalog
      // est appelé de façon synchrone pendant le rendu (plusieurs fois par page), donc un
      // `toast.error` ici s'affichait à tort comme une erreur bloquante à chaque montage,
      // avant même que le chargement asynchrone ait eu le temps d'aboutir — alors que la
      // valeur se corrige ensuite au re-rendu suivant. `console.warn` reste disponible
      // pour le débogage sans alarmer l'utilisateur pour un état de chargement normal.
      console.warn(
        "TVA introuvable : le catalogue de ce véhicule n'est pas (encore) visible pour ce compte (catalogRef.geographicZone manquant)."
      );
      return {
        TVA: -1,
        TVA_INVERT: -1,
      };
    }
    return {
      TVA: catalogRef?.geographicZone?.tva,
      TVA_INVERT: catalogRef?.geographicZone?.tva + 1,
    };
  };
  return { getTVAByCatalog };
};

export default useTVA;
